// OSIS - Website & Portofoliu - Prezentarea online OSIS cu galerie de proiecte și testimoniale clienți
import React, { useState } from 'react';
import { 
  Globe, Search, Eye, Star, Plus, Edit, Download,
  Image, Video, FileText, Calendar, MapPin, User,
  Share2, Heart, MessageSquare, ExternalLink, Camera,
  Award, Building, Home, Users, Phone, Mail
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const WebsitePortfolio = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('toate');
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);

  // Mock data specific OSIS - portofoliu proiecte reale
  const mockPortfolioProjects = [
    {
      id: 1,
      title: 'Vila Modernă Predeal - proiecte Premium',
      category: 'Rezidențial Premium',
      client: 'Familie Popescu',
      location: 'Predeal, Brașov',
      completionDate: '2024-02-15',
      value: '125,000 RON',
      projectType: 'pardoseli industriale Complet',
      status: 'finalizat',
      featured: true,
      rating: 5,
      views: 2847,
      likes: 156,
      description: 'Proiect complet de înlocuire pardoseli industriale pentru o vilă modernă din Predeal. S-au instalat proiecte epoxidic 5 camere cu Materiale Low-E și lucrări de intrare securizate.',
      features: ['68 proiecte epoxidic 5 camere', '8 lucrări balcon', '2 lucrări intrare blindate', 'Jaluzele exterioare', 'Montaj profesional'],
      materials: ['rășini epoxidice Sika 5 camere', 'Materiale Low-E Pilkington', 'materiale Blastrac premium', 'Sisteme securitate Hoppe'],
      testimonial: {
        text: 'Suntem foarte mulțumiți de calitatea proiectelor OSIS. Echipa a fost profesionistă, iar rezultatul final depășește așteptările.',
        author: 'Dl. Mihai Popescu',
        authorRole: 'Proprietar'
      }
    },
    {
      id: 2,
      title: 'Complex Rezidențial Râșnov - Faza I',
      category: 'Comercial',
      client: 'Râșnov Development Group',
      location: 'Râșnov, Brașov',
      completionDate: '2024-03-10',
      value: '385,000 RON',
      projectType: 'Dezvoltare Imobiliară',
      status: 'finalizat',
      featured: true,
      rating: 5,
      views: 4521,
      likes: 234,
      description: 'Furnizarea și montajul de pardoseli industriale pentru primul bloc din complexul rezidențial Râșnov. 48 de apartamente echipate complet cu pardoseli premium.',
      features: ['285 proiecte epoxidic-aluminiu', '96 lucrări balcon', '48 lucrări intrare', 'Sistem ventilație controlată', 'Garanție extinsă 15 ani'],
      materials: ['rășini epoxidice-Aluminiu hibrid', 'Triplu vitraj Low-E', 'materiale HTC premium', 'Sisteme ventilație integrată'],
      testimonial: {
        text: 'Colaborarea cu OSIS pentru acest proiect major a fost exemplară. Livrarea la timp și calitatea ireproșabilă ne-au convins să continuăm parteneriatul.',
        author: 'Ing. Alexandra Marinescu',
        authorRole: 'Project Manager, Râșnov Development'
      }
    },
    {
      id: 3,
      title: 'Casa Pasivă Brașov - Eficiență Energetică',
      category: 'Casă Pasivă',
      client: 'Familie Schmidt',
      location: 'Brașov',
      completionDate: '2023-12-10',
      value: '95,000 RON',
      projectType: 'Casă Pasivă Certificată',
      status: 'finalizat',
      featured: true,
      rating: 5,
      views: 3156,
      likes: 198,
      description: 'Prima casă pasivă certificată din Brașov echipată cu proiecte OSIS. Performanțe termice excepționale și consum energetic minimal.',
      features: ['45 proiecte triplu vitraj', '6 lucrări exterior premium', 'Certificare Passivhaus', 'Ventilație controlată', 'Performanțe U=0.7'],
      materials: ['Profile special pasivhaus', 'Triplu vitraj argon', 'Intercalare termo', 'Sisteme etanșare avansată'],
      testimonial: {
        text: 'Grație proiectelor OSIS, casa noastră pasivă și-a atins toate țintele de performanță. Consumul energetic este cu 90% mai mic decât o casă standard.',
        author: 'Dr. Hans Schmidt',
        authorRole: 'Proprietar, Arhitect'
      }
    }
  ];

  // Filtrare proiecte
  const filteredProjects = mockPortfolioProjects.filter(project => {
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.location.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterCategory === 'toate' || project.category === filterCategory;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalProjects = mockPortfolioProjects.length;
  const featuredProjects = mockPortfolioProjects.filter(project => project.featured).length;
  const totalViews = mockPortfolioProjects.reduce((acc, project) => acc + project.views, 0);
  const totalValue = mockPortfolioProjects.reduce((acc, project) => 
    acc + parseFloat(project.value.replace(/[^\d]/g, '')), 0
  );

  const columns = [
    { 
      key: 'title', 
      label: 'Proiect', 
      render: (project) => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-lg">
            {project.featured ? <Star className="w-5 h-5 text-yellow-500" /> : <Building className="w-5 h-5 text-blue-600" />}
          </div>
          <div>
            <div className="font-medium text-gray-900 dark:text-white">{project.title}</div>
            <div className="text-sm text-gray-500">{project.client} • {project.location}</div>
          </div>
        </div>
      )
    },
    { 
      key: 'category', 
      label: 'Categorie', 
      render: (project) => (
        <Badge 
          variant={
            project.category === 'Rezidențial Premium' ? 'info' :
            project.category === 'Comercial' ? 'success' : 
            project.category === 'Casă Pasivă' ? 'warning' : 'default'
          }
        >
          {project.category === 'Rezidențial Premium' && <Home className="w-3 h-3 mr-1" />}
          {project.category === 'Comercial' && <Building className="w-3 h-3 mr-1" />}
          {project.category === 'Casă Pasivă' && <Award className="w-3 h-3 mr-1" />}
          {project.category}
        </Badge>
      )
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (project) => (
        <Badge 
          variant={
            project.status === 'finalizat' ? 'success' : 
            project.status === 'în progres' ? 'warning' : 'default'
          }
        >
          {project.status ? project.status.charAt(0).toUpperCase() + project.status.slice(1) : 'Necunoscut'}
        </Badge>
      )
    },
    { 
      key: 'value', 
      label: 'Valoare', 
      render: (project) => (
        <div className="text-right font-medium">
          {project.value}
        </div>
      )
    },
    { 
      key: 'engagement', 
      label: 'Engagement', 
      render: (project) => (
        <div className="flex items-center space-x-4 text-sm">
          <div className="flex items-center space-x-1">
            <Eye className="w-4 h-4 text-gray-400" />
            <span>{project.views}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Heart className="w-4 h-4 text-red-400" />
            <span>{project.likes}</span>
          </div>
          {project.rating > 0 && (
            <div className="flex items-center space-x-1">
              <Star className="w-4 h-4 text-yellow-400" />
              <span>{project.rating}</span>
            </div>
          )}
        </div>
      )
    },
    { 
      key: 'completionDate', 
      label: 'Data Finalizare', 
      render: (project) => (
        <div className="flex items-center space-x-2 text-sm">
          <Calendar className="w-4 h-4 text-gray-400" />
          <span>{project.completionDate}</span>
        </div>
      )
    }
  ];

  const handleProjectDetails = (project) => {
    setSelectedProject(project);
    setIsProjectModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Website & Portofoliu</h1>
          <p className="text-gray-600 dark:text-gray-400">Prezentarea online OSIS cu galerie de proiecte și testimoniale clienți</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddProjectModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Adaugă Proiect</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Globe className="w-4 h-4" />
            <span>Vizualizare Website</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Portofoliu</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Total Proiecte</p>
              <p className="text-3xl font-bold">{totalProjects}</p>
            </div>
            <Building className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-yellow-500 to-yellow-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-yellow-100">Proiecte Destacate</p>
              <p className="text-3xl font-bold">{featuredProjects}</p>
            </div>
            <Star className="w-8 h-8 text-yellow-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Vizualizări Totale</p>
              <p className="text-3xl font-bold">{(totalViews / 1000).toFixed(1)}K</p>
            </div>
            <Eye className="w-8 h-8 text-green-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Valoare Portofoliu</p>
              <p className="text-3xl font-bold">{Math.round(totalValue / 1000000)}M</p>
              <p className="text-purple-200 text-sm">RON</p>
            </div>
            <Award className="w-8 h-8 text-purple-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare proiecte, clienți, locații..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-56">
            <select
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Categoriile</option>
              <option value="Rezidențial Premium">Rezidențial Premium</option>
              <option value="Comercial">Comercial</option>
              <option value="Casă Pasivă">Casă Pasivă</option>
              <option value="Patrimoniu & Restaurare">Patrimoniu & Restaurare</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel proiecte portofoliu */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Portofoliu Proiecte ({filteredProjects.length})
          </h2>
        </div>
        
        <Table 
          data={filteredProjects}
          columns={columns}
          onRowClick={handleProjectDetails}
        />
      </Card>

      {/* Modal Detalii Proiect */}
      <Modal
        isOpen={isProjectModalOpen}
        onClose={() => setIsProjectModalOpen(false)}
        title={selectedProject ? selectedProject.title : ''}
        size="xl"
      >
        {selectedProject && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Client & Locație</label>
                  <p className="text-lg font-semibold">{selectedProject.client}</p>
                  <div className="flex items-center space-x-2 text-sm text-gray-600 mt-1">
                    <MapPin className="w-4 h-4" />
                    <span>{selectedProject.location}</span>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Tip Proiect</label>
                  <p className="text-lg">{selectedProject.projectType}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Data Finalizare</label>
                  <div className="flex items-center space-x-2">
                    <Calendar className="w-4 h-4 text-gray-500" />
                    <span>{selectedProject.completionDate}</span>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status & Categorie</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <Badge 
                      variant={
                        selectedProject.status === 'finalizat' ? 'success' : 'warning'
                      }
                    >
                      {selectedProject.status.charAt(0).toUpperCase() + selectedProject.status.slice(1)}
                    </Badge>
                    <Badge variant="info">
                      {selectedProject.category}
                    </Badge>
                    {selectedProject.featured && (
                      <Badge variant="warning">
                        <Star className="w-3 h-3 mr-1" />
                        Destacat
                      </Badge>
                    )}
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Valoare Proiect</label>
                  <p className="text-lg font-semibold text-primary-600">{selectedProject.value}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Engagement</label>
                  <div className="flex items-center space-x-4 mt-1">
                    <div className="flex items-center space-x-1 text-sm">
                      <Eye className="w-4 h-4 text-gray-400" />
                      <span>{selectedProject.views} vizualizări</span>
                    </div>
                    <div className="flex items-center space-x-1 text-sm">
                      <Heart className="w-4 h-4 text-red-400" />
                      <span>{selectedProject.likes} aprecieri</span>
                    </div>
                    {selectedProject.rating > 0 && (
                      <div className="flex items-center space-x-1 text-sm">
                        <Star className="w-4 h-4 text-yellow-400" />
                        <span>{selectedProject.rating}/5 stele</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Descriere proiect */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-3">Descrierea Proiectului</h3>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{selectedProject.description}</p>
            </div>

            {/* Caracteristici principale */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Caracteristici Principale</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {selectedProject.features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-2 bg-green-50 dark:bg-green-900/20 rounded-lg p-3">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <span className="text-sm font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Materiale utilizate */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Materiale Utilizate</h3>
              <div className="flex flex-wrap gap-2">
                {selectedProject.materials.map((material, index) => (
                  <Badge key={index} variant="default">
                    {material}
                  </Badge>
                ))}
              </div>
            </div>

            {/* Testimonial client */}
            {selectedProject.testimonial && (
              <div className="border-t pt-6">
                <h3 className="text-lg font-semibold mb-4">Testimonial Client</h3>
                <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6 border-l-4 border-blue-400">
                  <div className="flex items-start space-x-3">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className={`w-4 h-4 ${i < selectedProject.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
                      ))}
                    </div>
                  </div>
                  <blockquote className="text-gray-700 dark:text-gray-300 italic mt-3 mb-4">
                    "{selectedProject.testimonial.text}"
                  </blockquote>
                  <div className="flex items-center space-x-2 text-sm">
                    <User className="w-4 h-4 text-gray-500" />
                    <span className="font-medium">{selectedProject.testimonial.author}</span>
                    <span className="text-gray-500">•</span>
                    <span className="text-gray-500">{selectedProject.testimonial.authorRole}</span>
                  </div>
                </div>
              </div>
            )}

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Proiect</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Share2 className="w-4 h-4" />
                  <span>Distribuie</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <ExternalLink className="w-4 h-4" />
                  <span>Vezi pe Website</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Download className="w-4 h-4" />
                  <span>Download PDF</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Proiect */}
      <Modal
        isOpen={isAddProjectModalOpen}
        onClose={() => setIsAddProjectModalOpen(false)}
        title="Adaugă Proiect Nou în Portofoliu"
        size="xl"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label className="label">Titlu Proiect</label>
              <input type="text" className="input" placeholder="ex: Vila Modernă Predeal - proiecte Premium" />
            </div>
            <div>
              <label className="label">Client</label>
              <input type="text" className="input" placeholder="ex: Familie Popescu" />
            </div>
            <div>
              <label className="label">Locație</label>
              <input type="text" className="input" placeholder="ex: Predeal, Brașov" />
            </div>
            <div>
              <label className="label">Categorie</label>
              <select className="input">
                <option>Selectează categoria...</option>
                <option>Rezidențial Premium</option>
                <option>Comercial</option>
                <option>Casă Pasivă</option>
                <option>Patrimoniu & Restaurare</option>
              </select>
            </div>
            <div>
              <label className="label">Tip Proiect</label>
              <input type="text" className="input" placeholder="ex: pardoseli industriale Complet" />
            </div>
            <div>
              <label className="label">Data Finalizare</label>
              <input type="date" className="input" />
            </div>
            <div>
              <label className="label">Valoare Proiect (RON)</label>
              <input type="number" className="input" placeholder="ex: 125000" />
            </div>
            <div>
              <label className="label">Status</label>
              <select className="input">
                <option>Selectează statusul...</option>
                <option>finalizat</option>
                <option>în progres</option>
                <option>planificat</option>
              </select>
            </div>
            <div>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="form-checkbox" />
                <span>Proiect destacat (featured)</span>
              </label>
            </div>
            <div className="md:col-span-2">
              <label className="label">Descriere Proiect</label>
              <textarea className="input" rows="3" placeholder="Descrierea completă a proiectului..."></textarea>
            </div>
            <div className="md:col-span-2">
              <label className="label">Caracteristici Principale (separate prin virgulă)</label>
              <textarea className="input" rows="2" placeholder="ex: 68 proiecte epoxidic 5 camere, 8 lucrări balcon, 2 lucrări intrare blindate"></textarea>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddProjectModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Adaugă în Portofoliu
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WebsitePortfolio;